import React from 'react'
import classNames from 'classnames'
import { type Nil, type User, Utils } from '@pbt/pbt-ui-components'

import useGetPreferredContactMethod from '~/components/dashboard/clients/details/new-client-and-patient/useGetPreferredContactMethod'
import { ClientPreferencesChip } from '~/components/dashboard/clients/preferences/ClientPreferencesChip'
import type { TimetableEvent } from '~/types'

import MetadataList from './MetadataList'

import styles from './PatientDetailsHeader.module.scss'

const ClientInfo = ({
  appointment,
  hasActionsSlot,
  client,
}: {
  appointment?: TimetableEvent | Nil
  client: User | Nil
  hasActionsSlot: boolean
}) => {
  const clientName = Utils.getPersonString(client)
  const preferredContactMethod = useGetPreferredContactMethod({
    client,
    phoneOnly: true,
  })

  return (
    <div className={styles.clientInfo}>
      <ClientPreferencesChip
        isDisplayWidgetChirp
        appointment={appointment}
        className={styles.preferencesChip}
        clientId={client?.id}
      />
      <MetadataList
        isTruncated={hasActionsSlot}
        items={[
          {
            value: client?.id ? (
              <a
                className={classNames(styles.plainLink)}
                href={`/client/${client.id}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                {clientName}
              </a>
            ) : (
              Utils.getPersonString(client)
            ),
          },
          { value: preferredContactMethod.value || '' },
        ]}
      />
    </div>
  )
}

export default ClientInfo
